// Zen Analytics

import React, { useState } from "react";
import "./index.css";
import Loading from "../../components/Utilities/Loading/Loading";
import { GrDownload } from "react-icons/gr";
import {BarChart,Bar,XAxis,YAxis,Cell,ResponsiveContainer,CartesianGrid,} from "recharts";
import { CiCircleInfo } from "react-icons/ci";

export const Organizational = () => {
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState("All Time");
  const [selectedMonth, setSelectedMonth] = useState("All");

  const monthNames = [
    "All",
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  const yearsArray = ["All Time", "2023", "2024"];

  const colorMap = {
    Sales: "#7E8ED9",
    HR: "#49AF7C",
    Ops: "#CBD1F0",
    Marketing: "#C4EED9",
    Tech: "#89D4AF",
    Product: "#F0B86E",
    Design: "#49AF7C",
  };

  const surveyColorMap = {
    stronglyAgree: "#49AF7C",
    agree: "#F9CA47",
    neutral: "#89D4AF",
    disagree: "#7E8ED9",
    stronglyDisagree: "#B4BDE9",
  };

  const triviaData = [
    { name: "Team A", value: 4600 },
    { name: "Team B", value: 4200 },
    { name: "Team C", value: 3900 },
    { name: "Team D", value: 4100 },
  ];

  const leaderboardData = [
    { name: "Lawrence", image: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg" },
    { name: "Amanda", image: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg" },
    { name: "Chris", image: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg" },
  ];

  const surveyData = [
    { name: "Team A", value: 2700 },
    { name: "Team B", value: 2200 },
    { name: "Team C", value: 2100 },
    { name: "Team D", value: 2300 },
  ];

  const surveyResults = [
    {
      name: "Team A",
      stronglyAgree: 25,
      agree: 35,
      neutral: 20,
      disagree: 10,
      stronglyDisagree: 10,
    },
    {
      name: "Team B",
      stronglyAgree: 20,
      agree: 30,
      neutral: 30,
      disagree: 10,
      stronglyDisagree: 10,
    },
    {
      name: "Team C",
      stronglyAgree: 15,
      agree: 25,
      neutral: 35,
      disagree: 15,
      stronglyDisagree: 10,
    },
    {
      name: "Team D",
      stronglyAgree: 30,
      agree: 40,
      neutral: 15,
      disagree: 10,
      stronglyDisagree: 5,
    },
  ];

  const pulseMoodData = [
    { name: "Happy", value: 5 },
    { name: "Neutral", value: 9 },
    { name: "Angry", value: 3 },
    { name: "Sad", value: 2 },
    { name: "Anxious", value: 4 },
  ];

  const pulseCheckinData = [
    { name: "Product", value: 30 },
    { name: "Sales", value: 15 },
    { name: "Design", value: 45 },
  ];

  const renderBarChart = (data, xAxisKey, customColorMap) => {
    const chart = (
    <ResponsiveContainer width={data.length > 5 ? data.length * 80 : "100%"} height={200}>
      <BarChart data={data} margin={{ top: 0, right: 5, bottom: 5, left: -22 }}>
        <XAxis
          dataKey={xAxisKey}
          tick={{ fill: "#394B42", fontSize: "12px", fontFamily: "Quicksand", fontWeight: 500 }}
          axisLine={{ stroke: "#394B42" }}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: "#394B42", fontSize: "12px", fontFamily: "Quicksand", fontWeight: 500 }}
          axisLine={{ stroke: "#394B42" }}
          tickLine={false}
        />
        <Bar dataKey="value" barSize={45}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={customColorMap[entry[xAxisKey]]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
    );
    return data.length > 5 ? (
      <div className="scrollable-graph">
        <div className="scrollable-graph-inner">{chart}</div>
      </div>
    ) : (
      chart
    );
  };

  const renderHorizontalBarChart = (data, xAxisKey, customColorMap) => (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 5, right: 20, left: 20, bottom: 5 }}
      >
        <XAxis 
          type="number"
          tick={{ fill: "#394B42", fontSize: "12px", fontFamily: "Quicksand", fontWeight: 500 }}
          axisLine={{ stroke: "#394B42" }}
          tickLine={false}
        />
        <YAxis
          type="category"
          dataKey={xAxisKey}
          tick={{ fill: "#394B42", fontSize: "12px", fontFamily: "Quicksand", fontWeight: 500 }}
          axisLine={{ stroke: "#394B42" }}
          tickLine={false}
        />
        <CartesianGrid strokeDasharray="3 3" horizontal={false}/>
        <Bar dataKey="value" barSize={30}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={customColorMap[entry[xAxisKey]]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );

  const renderStackedChart = (data, colorMap) => (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data}>
        <XAxis
          dataKey="name"
          tick={{ fill: "#394B42", fontSize: "12px", fontFamily: "Quicksand", fontWeight: 500 }}
          axisLine={{ stroke: "#394B42" }}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: "#394B42", fontSize: "12px", fontFamily: "Quicksand", fontWeight: 500 }}
          axisLine={{ stroke: "#394B42" }}
          tickLine={false}
        />
        {Object.keys(colorMap).map((key) => (
          <Bar key={key} dataKey={key} stackId="a" fill={colorMap[key]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );

  return (
    <div className="content-trends-container">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dashboardofboxes">
            <div className="content-trends-top">
              {selectedYear !== "All Time" && (
                <div className="content-trends-filter">
                  <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                    {monthNames.map((month, index) => (
                      <option key={index} value={month}>{month}</option>
                    ))}
                  </select>
                </div>
              )}
              <div className="content-trends-filter">
                <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                  {yearsArray.map((year, index) => (
                    <option key={index} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              <div className="content-trends-download-div">
                <GrDownload />
                <span>Download</span>
              </div>
            </div>

            {/* Trivia Section */}
            <div className="dashboard-section">
              <div className="dashboard-header">
                <div className="section-title">Trivia</div>
                <div className="section-meta">
                  <span className="badge green">Total Participants: 467</span>
                  <span className="date-label">06/01/2024</span>
                  <CiCircleInfo/>
                </div>
              </div>
              <div className="section-content">
                <div className="section-content-parts">
                  <div className="zen-cards-subheading">Trivia Participation</div>
                  {renderBarChart(triviaData, "name", {
                    "Team A": "#49AF7C",
                    "Team B": "#89D4AF",
                    "Team C": "#C4EED9",
                    "Team D": "#C4EED9",
                  })}
                </div>
                <div className="section-content-parts-seperator"/>
                <div className="section-content-parts">
                  <div className="zen-cards-subheading">Trivia Leaderboard</div>
                  <ul className="leaderboard">
                  {leaderboardData.map((entry, index) => (
                    <li key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span>{["🥇", "🥈", "🥉"][index]}</span>
                      <img
                        src={entry.image}
                        alt={entry.name}
                        style={{ width: "24px", height: "24px", borderRadius: "50%" }}
                      />
                      <span>{entry.name}</span>
                    </li>
                  ))}
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Survey Section */}
            <div className="dashboard-section">
              <div className="dashboard-header">
                <div className="section-title">Survey</div>
                <div className="section-meta">
                  <span className="badge green">Responses: 467</span>
                  <span className="date-label">Survey ▼</span>
                </div>
              </div>
              <div className="section-content">
                <div className="section-content-parts">
                  <div className="zen-cards-subheading">Survey Participation</div>
                  {renderBarChart(surveyData, "name", {
                    "Team A": "#49AF7C",
                    "Team B": "#89D4AF",
                    "Team C": "#C4EED9",
                    "Team D": "#C4EED9",
                  })}
                </div>
                <div className="section-content-parts-seperator"/>
                <div className="section-content-parts">
                  <div className="zen-cards-subheading">Survey Results</div>
                  {renderStackedChart(surveyResults, surveyColorMap)}
                </div>
              </div>
            </div>

            {/* Pulse Check-ins Section */}
            <div className="dashboard-section">
              <div className="dashboard-header">
                <div className="section-title">Pulse Check-ins</div>
                <div className="section-meta">
                  <span className="badge green">Responses: 467</span>
                  <span className="date-label">Today ▼</span>
                </div>
              </div>
              <div className="section-content">
                <div className="section-content-parts">
                  <div className="zen-cards-subheading">Mood Check</div>
                  {renderBarChart(pulseMoodData, "name", {
                  Happy: "#49AF7C",
                  Neutral: "#7E8ED9",
                  Angry: "#CBD1F0",
                  Sad: "#F6D169",
                  Anxious: "#89D4AF",
                })}
                </div>
                <div className="section-content-parts-seperator"/>
                <div className="section-content-parts">
                  <div className="zen-cards-subheading">Team wise Happiness Rate</div>
                  {renderHorizontalBarChart(pulseCheckinData, "name", {
                    Product: "#C4EED9",
                    Sales: "#89D4AF",
                    Design: "#49AF7C",
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Organizational;
